import { render, staticRenderFns } from "./CreditDebitTab.vue?vue&type=template&id=8bc21b2a&scoped=true"
import script from "./CreditDebitTab.vue?vue&type=script&lang=js"
export * from "./CreditDebitTab.vue?vue&type=script&lang=js"
import style0 from "./CreditDebitTab.vue?vue&type=style&index=0&id=8bc21b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc21b2a",
  null
  
)

export default component.exports